import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f9dbbed"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "booking-setting__wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "アカウント設定", -1))
const _hoisted_3 = { class: "booking-setting__content pt-2" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "field grid input-component my-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start" }, "店舗名", -1))
const _hoisted_7 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_8 = { class: "flex align-items-center" }
const _hoisted_9 = { class: "field grid input-component my-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start" }, "アカウント名", -1))
const _hoisted_11 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = { class: "field grid input-component my-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start" }, "メールアドレス", -1))
const _hoisted_15 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_16 = { class: "flex align-items-center" }
const _hoisted_17 = { class: "field grid input-component my-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start" }, "その他の受信メール", -1))
const _hoisted_19 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_20 = { class: "flex align-items-center" }
const _hoisted_21 = { class: "field grid input-component my-5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start" }, "パスワード", -1))
const _hoisted_23 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_24 = { class: "flex align-items-center" }
const _hoisted_25 = { class: "submit mt-5 mb-8 lg:col-6 md:col-12 sm:col-12" }
const _hoisted_26 = { class: "flex justify-content-end" }

import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { ref, reactive, inject, onBeforeMount } from "vue";
import { get, set } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import ClientDetailService from "../services/client-details.services";
import Toast from "primevue/toast";
import Textarea from "primevue/textarea";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDetail',
  setup(__props) {

const toast = useToast();
const clinicId = ref(0);

const form = reactive<any>({
  data: {},
});

const handleSaveButton = async () => {
  var formData = new FormData();
  formData.append("name", form.data.name);
  formData.append("username", form.data.username);
  formData.append("email", form.data.email);

  if (form.data.secondary_emails && form.data.secondary_emails.trim() !== "") {
    formData.append("secondary_emails", form.data.secondary_emails);
  }

  if (form.data.password && form.data.password.trim() !== "") {
    formData.append("password", form.data.password);
  }
  await ClientDetailService.updateClientDetail(
    formData,
    () => notifySuccessMsg(toast, "保存が完了しました"),
    (error: any) => notityErrorMsg(toast, error.join(", "))
  );
  form.data.password = "";
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));

  const response = await ClientDetailService.getClientDetail((error: any) =>
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
  form.data = response.data;
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSaveButton, ["prevent"]),
          class: "mt-5"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_InputText, {
                  modelValue: form.data.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.data.name) = $event)),
                  placeholder: "Enter a name",
                  class: "w-100 input-custom"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_InputText, {
                  modelValue: form.data.username,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.data.username) = $event)),
                  placeholder: "Enter a new username",
                  class: "w-100 input-custom"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_InputText, {
                  modelValue: form.data.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.data.email) = $event)),
                  placeholder: "メールアドレスを入カしてください",
                  class: "w-100 input-custom"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(Textarea), {
                  modelValue: form.data.secondary_emails,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.data.secondary_emails) = $event)),
                  placeholder: "メールアドレスをコンマ（半角文字）で区切って入力してください。\nコンマの後にスペースを入れないで次のアドレスを入力してください\n例：example@gmail.com,example@gmail.com",
                  class: "w-100 input-custom"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_InputText, {
                  modelValue: form.data.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.data.password) = $event)),
                  placeholder: "新しいパスワードを入力してください",
                  class: "w-100 input-custom"
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ], 40, _hoisted_4),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Button, {
              type: "button",
              class: "btn-orange m-0",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSaveButton())),
              label: "保存する"
            })
          ])
        ])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})